module.exports = __webpack_public_path__ + "static/media/chain-secure.9f7315a6.svg";